import ImgPopupLayer from "../theme/img-popup-layer/img-popup-layer";

$(function () {
    var imgPopupLayer = new ImgPopupLayer();

    // to make image popup open
    $(".non-title-content-zone img").each(function () {
        var tmpSrcStr = $(this).attr("src");
        var tmpAltStr = $(this).attr("alt");

        $(this).click(function () {
            imgPopupLayer.toShow(tmpSrcStr, tmpAltStr);
        });
    });

    // 讓內文的連結都在新頁開啟
    $(".non-title-content-zone a").each(function () {
        $(this).attr("rel", "noopener noreferrer");
        $(this).attr("target", "_blank");
    });

});